import styled from "@emotion/native"
import { Text, Spacing } from "../../ui-components"
import type { CountryItem, CountryLocale } from "./types"
import { getCountryName } from "./utils"

type PopularCountriesSectionProps = {
  countries: CountryItem[]
  lang?: CountryLocale
  onSelect: (country: CountryItem) => void
}

export function PopularCountriesSection({
  countries,
  lang = "en",
  onSelect,
}: PopularCountriesSectionProps) {
  if (!countries.length) {
    return null
  }

  return (
    <Section>
      <Text type="label2" color="tertiary3">
        Popular
      </Text>
      <Spacing top={10} />
      <ChipsRow>
        {countries.map((country) => (
          <Chip key={country.code} onPress={() => onSelect(country)}>
            <Text type="body1">{country.flag}</Text>
            <Text type="body2" color="primary">
              {getCountryName(country, lang)}
            </Text>
            <Text type="body2" color="royalBlue">
              {country.dial_code}
            </Text>
          </Chip>
        ))}
      </ChipsRow>
    </Section>
  )
}

const Section = styled.View`
  padding-bottom: 16px;
`

const ChipsRow = styled.View`
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`

const Chip = styled.Pressable`
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.phoneNumberInput.backgroundColor};
  border-width: 1px;
  border-color: ${({ theme }) => theme.phoneNumberInput.countryCodeSeparatorBorderColor};
`
